import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User, WebStorageStateStore, InMemoryWebStorage } from 'oidc-client-ts';
//import { UserManager, UserManagerSettings, User, WebStorageStateStore, InMemoryWebStorage } from '../../../lib/oidc-client.min';
import { environment } from '../../environments/environment';
import { NotificationService } from '../common/component/notification/notification.service';
import { NotificationTypes } from '../common/component/notification/notification.component';

export function getClientSettings(): UserManagerSettings {
  return {
    authority: environment.authority,
    client_id: environment.client_id,
    redirect_uri: environment.redirect_uri,
    post_logout_redirect_uri: environment.post_logout_redirect_uri,
    response_type: 'code',
    scope: 'openid profile',
    filterProtocolClaims: true,
    automaticSilentRenew: false,
    loadUserInfo: false,
    extraQueryParams: { 'resource': 'https://graph.microsoft.com' },
    userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
    stateStore: new WebStorageStateStore({ store: sessionStorage })
  };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private manager: UserManager = new UserManager(getClientSettings());
  private user: User;

  constructor(private notificationService: NotificationService) {
    this.manager.getUser().then((user: any) => { this.user = user });

    this.manager.getUser().then((user: any) => { this.user = user });
    this.manager.events.addAccessTokenExpiring(x => {
      console.log('Acess token expiring event');
      this.notificationService.alert(NotificationTypes.SessionWarning, '', null);
    });

  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  getIdTokenValue(): string {
    if (this.user) {
      return this.user.id_token;
    }
    else {
      return '';
    }
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  public renewToken() {
    return this.manager.signinSilent().then(u => {
      this.user = u;
    }).catch(er => {
      console.log(er);
    });
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(
      (user: any) => { this.user = user },
      (error: any) => console.error(error)
    );
  }
}
